<template lang="pug">
main.student
	include ../includes/header-basic.pug
	section#bienvenida.pm-5.welcome
		.image-background
			.image(style="opacity: 1;background-image: url('https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1920&q=50');")
		article.container.text-center
			.row.pt-5.justify-content-center
				.col-12
					h2(attr-animate="1").h1.text-white Para cualquier deporte en comunidad
					p(attr-animate="2").lead.text-white Reserva tu clase y entrena sin preocupaciones con BoxMagic
					div(attr-animate="3")
						.row
							.col
								a.btn-app.btn.btn-xs.mr-3.mb-3.btn-outline-white.text-left(href="https://itunes.apple.com/us/app/boxmagic/id1199480572?l=es&ls=1&mt=8" target="blank_")
									span.media.align-items-center
										span.d-flex.mr-2
											span.fab.fa-apple.font-size-icon
										span.media-body
											span.d-block 
												small Descarga desde
											strong.font-size-14 App Store
								a(href="https://play.google.com/store/apps/details?id=app.boxmagic.cl" target="blank_").btn-app.btn.btn-xs.mr-3.mb-3.btn-outline-white.text-left
									span.media.align-items-center
										span.d-flex.mr-2
											span.fab.fa-google-play.font-size-icon
										span.media-body
											span.d-block 
												small Descarga desde
											strong.font-size-14 Google Play
								a(href="https://boxmagic.cl/login?utm_source=landing+page+student&utm_medium=web" target="blank_").btn-app.btn.btn-xs.mr-3.mb-3.btn-outline-white.text-left
									span.media.align-items-center
										span.d-flex.mr-2
											span.fas.fa-globe.font-size-icon
										span.media-body
											span.d-block 
												small Desde
											strong.font-size-14 WebApp

	section#funciones.py-5.howitwork
		.container
			.row.d-flex.flex-row.align-items-center.align-self-center.justify-content-center.text-center
				.col-12.col-sm-8.mb-5
					span.badge-primary.mb-3 Características
					h3 Cómo funciona
					p Con pocos pasos creas tu cuenta de alumnos donde tendrás el control y manejo sobre tus pagos, las reservas de tus clases, el registro de tu progreso deportivo y mucho más!
		
			.row.d-flex.flex-row.text-center
				.col-sm-4.col-12
					.icon.mb-3
						i.far.fa-credit-card
					h6 Membresía
					p Paga tu membresía directo al centro deportivo, selecciona tu plan y lleva todo el control de tus pagos.
				.col-sm-4.col-12
					.icon.mb-3
						i.far.fa-calendar-check
					h6 Horarios
					p Revisa los horarios de las clases, reserva, revisa que otros compañeros asistirán y sus resultados por clase.
				.col-sm-4.col-12
					.icon.mb-3
						i.fas.fa-graduation-cap
					h6 Progreso
					p Ingresa tus resultados, agrega marcas a vencer, records máximos y registra tu progreso histórico junto con tus compañeros

	include ../includes/cases.pug
	section#descarga.py-5.download-app
		.image-background
			//- <%%= BASE_URL %%>
			.image(style="background-image: url('images/background-downloadapp.jpg');")
		.container.py-5
			.row
				.col-12.col-sm-6
				.col-12.col-sm-6
					h3.text-white.mt-3.h1 Comienza a organizar tus clase ahora con boxmagic
					p.text-white.lead Nuestra aplicación está disponible en cualquier dispositivo. Haz que tus alumnos la descarguen y empiecen a reservar.
					.row
						.col
							a(href="https://itunes.apple.com/us/app/boxmagic/id1199480572?l=es&ls=1&mt=8" target="blank_").btn.btn-xs.mr-3.mb-3.btn-outline-white.text-left
								span.media.align-items-center
									span.d-flex.mr-2
										span.fab.fa-apple.font-size-26
									span.media-body
										span.d-block Descarga en
										strong.font-size-14 App Store
							a(href="https://play.google.com/store/apps/details?id=app.boxmagic.cl" target="blank_").btn.btn-xs.mr-3.mb-3.btn-outline-white.text-left
								span.media.align-items-center
									span.d-flex.mr-2
										span.fab.fa-google-play.font-size-26
									span.media-body
										span.d-block Descarga en
										strong.font-size-14 Google Play
							hr.mt-0.mb-3(style="border-color: transparent;")
							a(href="https://boxmagic.cl/login" target="blank_").btn.btn-xs.mr-3.mb-3.btn-outline-white.text-left
								span.media.align-items-center
									span.d-flex.mr-2
										span.fas.fa-globe.font-size-26
									span.media-body
										span.d-block Conectar desde
										strong.font-size-14 Web App
							
	include ../includes/footer.pug

</template>

<script>

	export default {
		name: 'student',
	}

</script>